import React, { useState } from 'react';
import styled from 'styled-components';
import { ArrowDown } from '../../assets/icons/Icons';

const FAQList = ({ faqs }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <FAQListContainer>
            {faqs.map((faq, index) => (
                <FAQItem key={index} onClick={() => toggleFAQ(index)}>
                    <QuestionRow>
                        <QuestionText>{faq.question}</QuestionText>
                        <ArrowIcon open={openIndex === index}>
                            <ArrowDown width={18} height={18} />
                        </ArrowIcon>
                    </QuestionRow>

                    {openIndex === index && (
                        <Answer>
                            <p style={{ whiteSpace: "pre-line", margin: 0 }}>{faq.answer}</p>
                        </Answer>
                    )}
                </FAQItem>
            ))}
        </FAQListContainer>
    );
};

// Styled Components
const FAQListContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const FAQItem = styled.div`
    width: 100%;
    padding: 1rem 1.25rem;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
    border-radius: 1.5rem;
    
    &:hover {
        background: ${({ theme }) => theme.backgroundLight};
    }

    @media (max-width: 600px) {
        padding: 1rem 1rem;
    }
`;

const QuestionRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
`;

const QuestionText = styled.p`
    font-size: 1.125rem;
    color: ${({ theme }) => theme.textPrimary};
    font-weight: 500;
    margin: 0;

    @media (max-width: 600px) {
        font-size: 1rem;
    }
`;

const ArrowIcon = styled.div`
    transition: transform 0.3s ease-in-out;
    transform: ${({ open }) => (open ? "rotate(180deg)" : "rotate(0)")};
`;

const Answer = styled.p`
    margin: 0.5rem 0 0 0;
    font-size: 1rem;
    color: ${({ theme }) => theme.textSecondary};
    line-height: 1.6;

    @media (max-width: 600px) {
        font-size: 0.875rem;
    }
`;

export default FAQList; 